import { Box, styled } from '@mui/material';
import React, { useCallback } from 'react';
import { useTheme } from '@mui/material/styles';
import { RGBA_COLORS } from '@/common/presentation/constants/colors';
import { getMarkerColor, getMarkerIcon } from './MarkerUtils';

import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { FeatureMarkerProps } from './MarkerTypes';
import PinShape from './pinShape';

const IconContainer = styled(Box)<{ color: string }>(({ color }) => ({
  width: 34,
  height: 34,
  borderRadius: '50%',
  background: color,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

const StyledPinShape = styled(PinShape)({
  transition: 'all 0.2s ease-in-out',
  cursor: 'pointer',
  '&:hover': {
    transform: 'scale(1.1)',
    filter: `drop-shadow(0 4px 8px ${RGBA_COLORS.GRAY_20})`
  }
});

const FeatureMarker: React.FC<FeatureMarkerProps> = ({ featureId, position, type, onMarkerClick, onDragEnd }) => {
  const theme = useTheme();
  const color = getMarkerColor(type, theme);
  const Icon = getMarkerIcon(type);

  const handleClick = useCallback(
    (e: google.maps.MapMouseEvent) => {
      if (e.domEvent.currentTarget instanceof google.maps.marker.AdvancedMarkerElement) {
        onMarkerClick?.(e.domEvent.currentTarget, featureId);
      }
    },
    [onMarkerClick, featureId]
  );

  const handleDragEnd = useCallback(
    (e: google.maps.MapMouseEvent) => {
      if (onDragEnd && e.latLng) {
        onDragEnd({ lat: e.latLng.lat(), lng: e.latLng.lng() });
      }
    },
    [onDragEnd]
  );

  return (
    <AdvancedMarker position={position} onClick={handleClick} draggable={!!onDragEnd} onDragEnd={handleDragEnd}>
      <StyledPinShape>
        <IconContainer color={color}>
          <Icon sx={{ fontSize: 24, color: 'common.white' }} />
        </IconContainer>
      </StyledPinShape>
    </AdvancedMarker>
  );
};

export default FeatureMarker;
